import { useState, useEffect } from 'react';
import { GranularPermissions, FULL_PERMISSIONS } from '@/types/permissions';
import config from '@/config';

interface RoleInfo {
  _id: string;
  name: string;
}

export const usePermissions = () => {
  const [permissions, setPermissions] = useState<GranularPermissions | null>(null);
  const [adminType, setAdminType] = useState<string | null>(null);
  const [role, setRole] = useState<RoleInfo | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPermissions = async () => {
      try {
        const response = await fetch(`${config.apiUrl}${config.endpoints.admin.permissions}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include', // Use httpOnly cookies for authentication
        });
        
        if (!response.ok) {
          throw new Error(`Failed to fetch permissions: ${response.status}`);
        }
        
        const { data } = await response.json();
        
        setPermissions(data.permissions);
        setAdminType(data.adminType);
        
        // Capture role info for SUB_ADMIN
        if (data.adminType === 'SUB_ADMIN' && data.role) {
          setRole(data.role);
        }
      } catch (error) {
        console.error('Failed to fetch permissions:', error);
        // Set default values for ADMIN if API fails
        setAdminType('ADMIN');
        setPermissions(FULL_PERMISSIONS);
      } finally {
        setLoading(false);
      }
    };
    
    fetchPermissions();
  }, []);

  return { permissions, adminType, role, loading };
};
